import {
    LOAD_REPORTS,
    LOAD_REPORTS_SUCCESS,
    LOAD_REPORTS_FAILED,
    SORT_REPORTS,
    FILTER_DATE,
    FILTER_DATE_TYPE,
    RESET_STATE,
} from "./types";
import axios from '../../lib/axios';
import config from '../../config/app-config.json';

const pollReportStatus = async (queryId: string, s3Key: string): Promise<string> => {
    const maxAttempts = 60; // ~5 minutes at 5s intervals
    for (let i = 0; i < maxAttempts; i++) {
        await new Promise(resolve => setTimeout(resolve, 5000));
        const response = await axios.get(`${config.serviceUrl}/report`, {
            params: { queryId, s3Key }
        });
        const data = response.data;
        if (data && typeof data === 'object' && data.status === 'complete') {
            return data.url;
        }
        if (data && typeof data === 'object' && data.status === 'failed') {
            throw new Error(data.error || 'Report generation failed');
        }
        // Still processing — continue polling
    }
    throw new Error('Report generation timed out');
};

// Send calendar dates as yyyy-MM-dd (local calendar day). The backend already parses that
// form; Date.toString() depended on the browser timezone and could shift the day for users
// whose local midnight is before UTC midnight.
const toDateParam = (value: any): string => {
    if (value instanceof Date && !isNaN(value.getTime())) {
        const pad = (n: number) => (n < 10 ? '0' + n : '' + n);
        return `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())}`;
    }
    return value == null ? '' : `${value}`;
};

const errorMessage = (err: any): string => {
    if (err && err.response && err.response.data && err.response.data.error) {
        return err.response.data.error;
    }
    return (err && err.message) || 'Report generation failed';
};

export const loadReport = (filterByDate, filterByDateType, scriptId) => {
    return async (dispatch: any) => {
        dispatch({
            type: LOAD_REPORTS,
            payload: ''
        })

        try {
            const response = await axios.get(`${config.serviceUrl}/report`, {
                params: {
                    scriptId: scriptId,
                    filterByDateTo: toDateParam(filterByDate.to),
                    filterByDateFrom: toDateParam(filterByDate.from),
                    filterByDateType: `${filterByDateType.value}`,
                }
            });

            const data = response.data;

            // If the backend returned a processing status, poll until complete
            if (data && typeof data === 'object' && data.status === 'processing') {
                const url = await pollReportStatus(data.queryId, data.s3Key);
                dispatch({
                    type: LOAD_REPORTS_SUCCESS,
                    payload: url
                });
            } else {
                // Backend returned the URL directly (query finished within 25s)
                dispatch({
                    type: LOAD_REPORTS_SUCCESS,
                    payload: data
                });
            }
        } catch (err) {
            // Without this a failed or timed-out export left the spinner on forever.
            dispatch({
                type: LOAD_REPORTS_FAILED,
                payload: errorMessage(err)
            });
        }
    }
}

export const sortReport = col => {
    return dispatch => dispatch({
        type: SORT_REPORTS,
        payload: col
    })
}

export const filterByDate = (value) => {
    return {
        type: FILTER_DATE,
        payload: value
    }
}

export const filterByDateType = (value) => {
    return {
        type: FILTER_DATE_TYPE,
        payload: value
    }
}

export const resetState = () => {
    return dispatch => dispatch({
        type: RESET_STATE,
        payload: []
    })
}
